module.exports = __webpack_public_path__ + "static/media/przeslony-dla-systemu-nylofor.f138349e.pdf";